"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonLoadingWrapper = exports.StyledButtonIcon = exports.StyledButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Responsive_1 = require("../../shared/Responsive");
const Icon_1 = require("../Icon");
const ButtonState_styles_1 = require("./ButtonState.styles");
/**
 * The problem: JSDOM uses a third-party CSS selector engine called nwsapi,
 * and it doesn't support the :has() selector. This causes Jest tests to fail when parsing styles.
 *
 * The solution: We check if the environment is 'test' and conditionally exclude styles
 * using :has() to ensure Jest can run tests without encountering syntax errors.
 *
 * https://github.com/jsdom/jsdom/issues/3506
 */
const isTestEnv = process.env.NODE_ENV === "test";
exports.StyledButton = styled_components_1.default.button `
    border-radius: var(--ds-border-radius);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    gap: 0.25rem;
    border: none;

    font-family: var(--ds-font-family);
    font-weight: bold;
    text-align: center;
    cursor: pointer;

    padding: 0.375rem 0.5rem;

    ${({ $isButtonFullWidth }) => {
    return ($isButtonFullWidth &&
        (0, styled_components_1.css) `
                width: 100%;
            `);
}}

    ${({ $size }) => {
    return $size && (0, Responsive_1.responsiveMapToMedia)($size, ButtonState_styles_1.buttonSizeStyles);
}}

    ${({ $appearance }) => {
    return $appearance && (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonStyles);
}}

    // Reduces the buttons left padding when an icon is left of a text element
    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(svg:first-child) {
            ${({ $size }) => {
        return ($size &&
            (0, Responsive_1.responsiveMapToMedia)($size, ButtonState_styles_1.buttonSizeIconOnLeftSideStyles));
    }}
        }
    `}

    // Reduces the buttons right padding when an icon is right of a text element
    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(svg:last-child) {
            ${({ $size }) => {
        return ($size &&
            (0, Responsive_1.responsiveMapToMedia)($size, ButtonState_styles_1.buttonSizeIconOnRightSideStyles));
    }}
        }
    `}

    // Hover styles
    &:hover {
        ${({ $appearance, $loading }) => {
    if ($loading)
        return;
    return ($appearance &&
        (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonHoverStyles));
}}
    }

    // Active styles
    &:active {
        ${({ $appearance, $loading }) => {
    if ($loading)
        return;
    return ($appearance &&
        (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonHoverStyles));
}}
    }

    // Focus styles
    &:not([disabled]):not([tabindex="-1"]):focus {
        outline: none;

        box-shadow: 0 0 0 2px var(--ds-color-white),
            0 0 0 4px var(--ds-color-blue-100);

        ${({ $appearance, $loading }) => {
    if ($loading)
        return;
    return ($appearance &&
        (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonHoverStyles));
}}
    }

    // Disabled styles
    &:disabled {
        border: none;
        box-shadow: none;
        cursor: not-allowed;

        ${({ $appearance }) => {
    return ($appearance &&
        (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonDisabledStyles));
}}
    }

    // Loading styles
    ${({ $loading, $appearance }) => {
    return ($loading &&
        $appearance &&
        (0, Responsive_1.responsiveMapToMedia)($appearance, ButtonState_styles_1.buttonDisabledStyles));
}}

    ${({ $loading }) => {
    return ($loading &&
        (0, styled_components_1.css) `
                cursor: not-allowed;
                box-shadow: none;
                &:not([disabled]):not([tabindex="-1"]):focus {
                    box-shadow: none;
                }
            `);
}}
    
    // Loading message styles for icon only 
    ${({ $loading, $size }) => {
    if ($loading && $size) {
        return (0, Responsive_1.responsiveMapToMedia)($size, ButtonState_styles_1.buttonSizeLoadingIconOnlyStyles);
    }
}}
    
    // Loading message styles for icon and text 
    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(span:nth-of-type(1)):has(span:nth-of-type(2)) {
            ${({ $loading, $size, }) => {
        if ($loading && $size) {
            return (0, Responsive_1.responsiveMapToMedia)($size, ButtonState_styles_1.buttonSizeLoadingIconWithTextStyles);
        }
    }}
        }
    `}
`;
exports.StyledButtonIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    width: 1.5rem;
    height: 1.5rem;

    ${({ $buttonAppearance }) => {
    return (0, Responsive_1.responsiveMapToMedia)($buttonAppearance, ButtonState_styles_1.buttonIconStyles);
}}

    ${({ $buttonAppearance, $disabled }) => {
    if ($disabled) {
        return (0, Responsive_1.responsiveMapToMedia)($buttonAppearance, ButtonState_styles_1.buttonIconDisabledStyles);
    }
}}
`;
exports.StyledButtonLoadingWrapper = styled_components_1.default.span `
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
`;
//# sourceMappingURL=Button.styles.js.map